<div class="w900 mt-15">
  <div class="form" [formGroup]="form">
    <div class="form-row">
      <label for="transactionCode">{{ 'selling.bracelet_search' | translate }}</label>
        <p class="hint">{{'selling.bracelet_search_hint' | translate}}</p>
        <input class="form-control" id="transactionCode" formControlName="tiTuiTc"
              [placeholder]="'selling.bracelet_search' | translate"  (keyup.enter)="onSearchClick()">
    </div>
    <div class="form-row">
      <label for="telephone">{{ 'selling.bracelet_telephone' | translate }}</label>
      <p class="hint">{{'selling.bracelet_telephone_hint' | translate}}</p>
      <input class="form-control mtop" id="telephone" formControlName="customerPhone"
        [placeholder]="'selling.bracelet_telephone' | translate"  (keyup.enter)="onSearchClick()">
    </div>
    <div class="form-row">
      <label for="email">{{ 'selling.bracelet_email' | translate }}</label>
      <input class="form-control" id="email" formControlName="email"
        [placeholder]="'selling.bracelet_email' | translate"  (keyup.enter)="onSearchClick()">
    </div>
    <div class="form-row-2">
      <div class="form-col">
        <label for="firstname">{{ 'selling.bracelet_firstname' | translate }}</label>
        <input class="form-control" id="firstname" formControlName="ownerName"
          [placeholder]="'selling.bracelet_firstname' | translate"  (keyup.enter)="onSearchClick()">
      </div>
      <div class="form-col">
        <label for="lastname">{{ 'selling.bracelet_lastname' | translate }}</label>
        <input class="form-control" id="lastname" formControlName="ownerSurname"
          [placeholder]="'selling.bracelet_lastname' | translate"  (keyup.enter)="onSearchClick()">
      </div>
    </div>
    <div class="buttons">
      <button (click)="reset(true)" class="btn-outlined-orange text-uppercase">
        {{ 'general.cancel' | translate }}
      </button>

      <button (click)="onSearchClick()" class="btn-orange orange-shadow text-uppercase">
        @if (!isLoading) {
          {{'general.search' | translate}}
        } @else {
          <div class="loader-inline" style="margin: 0 auto;"></div>
        }
      </button>
      @if (isFormValid) {
        <p class="text">{{'selling.bracelet_filter_danger' | translate }}</p>
      }
    </div>
  </div>

<!--    @for (item of items; track item) {-->
<!--      <app-management-card [item]="item" [transactionCode]="form.controls.value">-->
<!--      </app-management-card>-->
<!--    }-->

  <div class="cart-grid mb-30" [class.mb-30]="items.length">
    @for (item of items; track item) {
      <div class="cart-grid-item">
        <div style="position: relative;">
          <div>
            <app-curved-header [title]="item.label" [color]="'#004580'">
            </app-curved-header>
          </div>
          <div class="body-cart">
            <app-management-card [item]="item" [transactionCode]="form.controls.value">
            </app-management-card>
          </div>
        </div>
      </div>
    }
  </div>

  @if (!items.length && isSearchDone) {
    <div class="empty-cart-cls text-center mb-80" [class.mt-30]="isWebMobile">
      <div class="empty-cart-icon"></div>
      <h4 class="not-found-text">{{'general.no_results' | translate}}</h4>
    </div>
  }
</div>


